import { useContext } from "react"
import { AuthContext } from "../context/auth"

export default function useLogin() {
    const { login } = useContext(AuthContext)
    return login
}
